import { useAppStore } from '@/stores/AppStore'
import { useAuthStore } from '@/stores/authenticated/AuthStore'
import { useEngineerStore } from '@/stores/authenticated/EngineerStore.js'
import { useSiteStore } from '@/stores/authenticated/SiteStore.js'
import { useWorkOrderStore } from '@/stores/authenticated/WorkOrderStore.js'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'

export function resetAllStores() {
  useAppStore().reset()
  resetUnauthenticatedStores()
  resetAuthenticatedStores()
}

export function resetUnauthenticatedStores() {
  useUnauthenticatedTokenStore().reset()
}

export function resetAuthenticatedStores() {
  useAuthStore().reset()
  useWorkOrderStore().reset()
  useSiteStore().reset()
  useEngineerStore().reset()
}
